import React from "react";

function Error({ hasError }: { hasError: boolean }) {
  if (!hasError) return null;
  return <div className="mb-40 text-slate-500 text-lg">Uh oh. Something went wrong. Please try again later.</div>;
}

export default Error;
